<template>
  <v-chart v-bind:option="option" autoresize />
</template>

<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
  TooltipComponent,
  LegendComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';

use([
  CanvasRenderer,
  PieChart,
  TooltipComponent,
  LegendComponent,
]);

export default {
  name: 'pie-chart',
  components: {
    VChart,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    series: function () {
      return {
        type: 'pie',
        radius: ['40%', '70%'],
        // avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 8,
          borderColor: '#fff',
          borderWidth: 2
        },
        // label: {
        //   alignTo: 'edge',
        //   edgeDistance: 0,
        //   show: false,
        //   position: 'center'
        // },
        emphasis: {
          label: {
            show: true,
            // fontSize: 24,
            // fontWeight: 'normal'
          }
        },
        // labelLine: {
        //   show: false
        // },
        data: this.value.slices
      };
    },
    option: function () {
      return {
        tooltip: {
          trigger: 'item',
          formatter: function(params) {
            return params.percent + "%";
          }
        },
        // legend: {
        //   top: '5%',
        //   left: 'center'
        // },
        series: this.series,
      }
    }
  }
};
</script>
